
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'

import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'

import '@/assets/styles.scss'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'

import Aura from '@primeuix/themes/aura'
import axiosPlugin from './plugins/axios'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'
import VueCookies from 'vue-cookies'
import { useNotifications } from './utils/useNotifications'
import vFocus from '@/directives/vFocus'
const app = createApp(App)

app.use(Loading);
app.use(router)
app.use(store)
app.use(VCalendar, {
    componentPrefix: 'vc',
})

app.directive('focus', vFocus)
app.use(VueCookies)
app.provide('router', router);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.app-dark'
        }
    }
})


app.use(ToastService)
app.use(ConfirmationService)
app.use(axiosPlugin);
app.provide('loading', Loading);
app.provide('cookies', app.config.globalProperties.$cookies);
const options = {};

app.use(Toast, options);
app.provide('notificationService', useNotifications());
app.mount('#app')

